<template>
  <div class='sl-upload'>
    <div class="sl-upload-list" v-for="item in uploadList">
      <template v-if="item.status === 'finished'">
        <sl-img :src="item.id" :image-url="previewUrl" :method="type" :public="public" :extra="true">
          <div class="sl-upload-list-cover">
            <Icon type="ios-eye-outline"></Icon>
            <Icon style="position: absolute;top:5px;right:0px;font-size:13px;" type="md-close-circle" @click.native.stop="handleRemove(item)"></Icon>
          </div>
        </sl-img>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>
    <iUpload ref="upload" 
      :show-upload-list="false" 
      :default-file-list="defaultFileList"
      :on-success="handleSuccess" 
      :format="format" 
      :max-size="maxSize" 
      :on-format-error="handleFormatError" 
      :on-exceeded-size="handleMaxSize" 
      :headers="headers" 
      :data="extraData" 
      :before-upload="handleBeforeUpload" multiple type="drag" 
      :action="baseURL + action" 
      :paste="true" 
      :style="{display:'inline-block',width:size+'px'}" 
      v-show="uploadList.length<this.limit"
      >
      <div :style="{width:size+'px',height:size+'px',lineHeight:size+'px'}">
        <Icon type="ios-add" size="20"></Icon>
      </div>
    </iUpload>
    <div class="sl-upload-tip"><slot></slot></div>

  </div>
</template>
<script>
import { getReqHeaders , baseURL} from '@/util/request'
import { Upload as iUpload } from 'iview'
import imgViewer from '../img/img-viewer'

export default {
  name:'Upload',
  components:{ iUpload , imgViewer },
  data() {
    return {
      imgId: '',
      visible: false,
      uploadList: [],
      headers:{ },
      defaultFileList:[],
      previewValue:null,
      currentValue:null,
      baseURL
    }
  },
  props:{
    format:{
      default:function(){
        return ['jpg','jpeg','png','gif','bmp']
      }
    },
    onRemove:{
      type:Function,
      default:function(){
        return true
      }
    },
    getId:{
      type:Function,
      default:function(v){
        return v
      }
    },
    previewUrl:{
      type:String,
      default:''
    },
    action:{
      type:String,
      default:'/common/upload'
    },
    size:{
      type:Number,
      default:54
    },
    maxSize:{
      type:Number,
      default:8096
    },
    limit:{
      type:Number,
      default:1
    },
    value:{
      type: [String, Number, Array],
      default: ''
    },
    multiple:{
      type:Boolean,
      default:false
    },
    fullProps:{
      type:Boolean,
      default:false
    },
    data:{
      type:Object,
      default:function(){
        return {}
      }
    },
    // type：0、通用私有文件，1、快递员头像
    type:{
      type:[Number , String],
      default:0
    },
    public:{
      type:Boolean,
      default:false
    }
  },

  created(){
    this.headers = getReqHeaders()
    this.$watch('value' , function(nv){
      this.renderFileList(nv)
    },{immediate:true})
    
  },

  mounted() {
    //获取 文件列表的 引用
    //this.uploadList = this.$refs.upload.fileList
  },
  computed:{
    
    multipleMode(){
      return this.limit > 1
    },
    extraData(){
      return { ...this.data , type : this.type}
    }
  },
  methods: {

    renderFileList(value){
      if (value === '' || value === null) {
        this.defaultFileList = []
      }
      else if (JSON.stringify(value) !== JSON.stringify(this.currentValue)) {
        let initialValue = Array.isArray(value) ? value : [value]
        this.defaultFileList = initialValue.map(id=>({id}))
      }
      this.updateValue()

      this.$nextTick(()=>{
        this.uploadList = this.$refs.upload.fileList
      })
    },

    remove(file){
      let idx = this.uploadList.findIndex( i => (i.id == file.id || i.uid == file.uid) )
      if(idx >= 0){
        this.uploadList.splice(idx , 1)
        this.handleUpdate()
      }
    },
    handleRemove(file) {
      //hook
      if(this.onRemove){
        let ret = this.onRemove(file)

        if( typeof ret == 'boolean' ){
          if( ret ){
            this.remove(file)
          }
        }else{
          ret.then(resp => {
            if(resp){
              this.remove(file)
            }
          })
        }
      }else{
        this.remove(file)
      }
      //this.$emit('on-remove' , file)

    },

    handleSuccess(res, file , fileList) {
      file.id = this.getId(res.data)
      
      this.uploadList = fileList;//.map( i => ({id:i.id , name:i.name,uid:i.uid , size:i.size , status:i.status}))

      console.log(fileList.map(i=>i.id))
      this.handleUpdate()
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '错误的文件类型',
        desc: '文件 ' + file.name + ' 文件类型不匹配'
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '文件大小错误',
        desc: `文件  ${file.name} 必须在 ${maxSize}KB 以内.`
      });
    },
    handleBeforeUpload(file , fileList) {
      if(!this.action){
        this.$Notice.error('参数错误')
        return false
      }

      if (this.uploadList.length >= this.limit) {
        this.$Notice.warning({
          title: `最多允许上传${this.limit}张`
        })
        return false
      }

      return true
    },

    updateValue(){
      let { multipleMode } = this
      let currentValue
      if(this.fullProps){
        currentValue = multipleMode ? this.uploadList : this.uploadList[0]
      }else{
        currentValue = multipleMode ? this.uploadList.map(({id})=>id) : this.uploadList[0] ? this.uploadList[0].id : null
      }
      this.currentValue = currentValue
    },

    handleUpdate(){
      this.updateValue()

      let vModelValue 
      let { multipleMode , currentValue} = this
     
      if(currentValue){
        vModelValue = this.fullProps ? (multipleMode ? currentValue.map(({id})=>id) : currentValue.id) : currentValue
      }
      this.currentValue = currentValue

      this.$emit('change', vModelValue)
      this.$emit('input', vModelValue)
      this.$emit('on-update' , this.currentValue)
    }
  }
}

</script>
<style lang="scss">
.sl-upload-tip{
  color:#999;
}
.sl-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
  margin-right: 4px;

  img {
    width: 100%;
    height: 100%;
  }

  .sl-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);

    i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      margin: 0 2px;
    }
  }

  &:hover .sl-upload-list-cover {
    display: block;
  }
}
</style>